import { actionBound, computed, makeAutoObservable, makeObservable, observable } from "mobx";
import NewOrderItemDisplayType from "@/scenes/OrderManagement/enum/NewOrderItemDisplayType";
import {
    OrderItemDisplayData,
    getOrderItemDisplayDataStorage,
    saveOrderItemDisplayDataStorage,
} from "@/scenes/OrderManagement/store/OrderTableStorageStore/utils/orderItemDisplayType";
import {
    getOrderItemPicSizeStorage,
    saveOrderItemPicSizeStorage,
} from "@/scenes/OrderManagement/store/OrderTableStorageStore/utils/orderItemPicSize";

const MAX_DISPLAY_ORDER_ITEM_COUNT_KEY = "MAX_DISPLAY_ORDER_ITEM_COUNT_KEY";

/**
 * 商品列展示设置。订单列表和快速查单共用同一份本地缓存。
 */
export default class OrderItemColumnSettingStore {
    constructor() {
        makeAutoObservable(this);

        this.initMaxDisplayCount();
    }

    picSize = getOrderItemPicSizeStorage();

    maxDisplayOrderItemCount: number | null = null;

    orderItemDisplayData: OrderItemDisplayData = getOrderItemDisplayDataStorage();

    get selectedOrderItemDisplayTypes() {
        const allTypes = Object.values(NewOrderItemDisplayType);
        const selectedTypes: NewOrderItemDisplayType[] = [];

        for (let i = 0; i < allTypes.length; i++) {
            const type = allTypes[i];

            if (this.orderItemDisplayData[type]) {
                selectedTypes.push(type);
            }
        }

        return selectedTypes;
    }

    /**
     * 因为不同的商品信息选项组合会导致商品列复杂的样式变化
     * 所以这里需要剥离掉GIFT选项，去重新计算样式
     */
    get selectedOrderItemDisplayTypesWithOutGiftTypes() {
        const types: NewOrderItemDisplayType[] = [];

        for (let i = 0; i < this.selectedOrderItemDisplayTypes.length; i++) {
            const type = this.selectedOrderItemDisplayTypes[i];

            if (type === NewOrderItemDisplayType.GIFT) {
                continue;
            }

            types.push(type);
        }

        return types;
    }

    initMaxDisplayCount() {
        const saved = localStorage.getItem(MAX_DISPLAY_ORDER_ITEM_COUNT_KEY);

        if (!saved) {
            return;
        }

        const count = parseInt(saved, 10);

        if (!Number.isNaN(count) && count >= 0) {
            this.maxDisplayOrderItemCount = count;
        }
    }

    setMaxDisplayCount(count: number | null) {
        if (count === null || isNaN(count) || count <= 0) {
            this.maxDisplayOrderItemCount = null;
            localStorage.removeItem(MAX_DISPLAY_ORDER_ITEM_COUNT_KEY);
            return;
        }

        this.maxDisplayOrderItemCount = count;
        localStorage.setItem(MAX_DISPLAY_ORDER_ITEM_COUNT_KEY, count.toString());
    }

    getOrderItemDisplayData() {
        this.orderItemDisplayData = getOrderItemDisplayDataStorage();

        return this.orderItemDisplayData;
    }

    setPicSize(size: number) {
        this.picSize = size;
        saveOrderItemPicSizeStorage(size);
    }

    onDisplayTypesChange(orderItemDisplayTypes: NewOrderItemDisplayType[]) {
        const data: OrderItemDisplayData = {};
        const allTypes = Object.values(NewOrderItemDisplayType);

        for (let i = 0; i < allTypes.length; i++) {
            const type = allTypes[i];

            data[type] = orderItemDisplayTypes.includes(type);
        }

        this.orderItemDisplayData = data;
        saveOrderItemDisplayDataStorage(data);
    }
}
